import { Injectable } from '@angular/core';
import { map, Observable, switchMap } from 'rxjs';
import { Player } from '../../models';
import {
  Configuration,
  ModulesPlayersEndpointsContractsPlayersUpdatePlayerRequestModel,
  PlayersService,
} from '../../api-client';
import { HttpClient } from '@angular/common/http';
import { NavigationRoute } from '../../models/config';
import { ConfigService } from '../config/config.service';
import { PlayerType } from '../../models/playerType';

@Injectable({
  providedIn: 'root',
})
export class PlayerService extends PlayersService {
  constructor(
    httpClient: HttpClient,
    config: Configuration,
    configService: ConfigService
  ) {
    super(httpClient, config.basePath!, config);

    this.playersNavItem = configService.config?.navigation?.find(
      (item) => item.name === 'Players'
    );
  }

  playersNavItem: NavigationRoute | undefined = undefined;

  /**
   * Get all players from API
   */
  getAll(): Observable<Player[]> {
    return super.getPlayersEndpoint().pipe(
      map((players: Player[]) =>
        players.map((player, index) => ({
          ...player,
          id: index,
        }))
      )
    );
  }

  getById(playerId: string): Observable<Player> {
    return super.getPlayerByIdEndpoint(playerId);
  }

  /**
   * Update player
   */
  updatePlayer(player: Player): Observable<Player> {
    // If readonly mode is enabled, just return the player by ID without updating
    if (this.playersNavItem?.readonly) {
      return super.getPlayerByIdEndpoint(player.playerId!);
    }

    const updateRequest = {
      lpgaId: player.lpgaId,
      tourId: player.tourId,
      wwgrId: player.wwgrId,
      firstName: player.firstName,
      middleName: player.middleName,
      lastName: player.lastName,
      playFirstName: player.playFirstName,
      playMiddleName: player.playMiddleName,
      playLastName: player.playLastName,
      shortName: player.shortName,
      gender: player.gender,
      city: player.city,
      stateId: player.stateId,
      countryId: player.countryId,
      hometown: player.hometown,
      isActive: player.isActive,
      image: player.image,
    } as ModulesPlayersEndpointsContractsPlayersUpdatePlayerRequestModel;

    return super.playersPlayerIdPut(player.playerId!, updateRequest).pipe(
      switchMap(() => super.getPlayerByIdEndpoint(player.playerId!))
    );
  }

  getPlayerTypes(): Observable<PlayerType[]> {
    return super.getPlayerTypesEndpoint();
  }

  getPlayerTypesByPlayer(playerId: string): Observable<PlayerType[]> {
    return super.getPlayerTypesByIdEndpoint(playerId);
  }
}
